(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairsPlatformTestsController', VirtualFairsPlatformTestsController);
    VirtualFairsPlatformTestsController.$inject = ['VirtualFairService', 'AdmService', '$uibModal'];

    function VirtualFairsPlatformTestsController(VirtualFairService, AdmService, $uibModal) {
        var vm = this;
        vm.flag                     = false;
        vm.virtualFairs             = [];
        vm.virtualFairSelected      = '';
        vm.getByFilter              = getByFilter;
        vm.getAllVirtualFair        = getAllVirtualFair;
        vm.openScheduleModal        = openScheduleModal;
        vm.openScheduleEditModal    = openScheduleEditModal;
        vm.openIssuesModal          = openIssuesModal;
        vm.arrayLength              = arrayLength;
        vm.exhibitorsSelect         = exhibitorsSelect;
        vm.exhibitorSelected        = '';
        vm.getAdmUsers              = getAdmUsers;
        vm.admUserSelected          = '';
        vm.status                   = [{ id: -1 , name : 'All'},{id : 1, name : 'Test completed'},{id : 0, name : 'Test pending'}];
        vm.statusSelected           = '';
        vm.withIssues               = [{ id: -1 , name : 'All'},{id : 1, name : 'Yes'},{id : 0, name : 'No'}];
        vm.withIssuesSelected       = '';

        /* Pagination */
        vm.pageChanged              = pageChanged;
        vm.setPage                  = setPage;
        vm.page                     = 1;
        function active() {
            getAllVirtualFair();
            getAdmUsers();
        }
        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }
        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }
        /* Fim pagination methods*/

        function getByFilter() {
            vm.query = {};
            vm.noResultMessage = '';
            vm.query['virtual_fair'] = vm.virtualFairSelected.id;
            if(vm.exhibitorSelected !== '' && vm.exhibitorSelected.id > 0){
                vm.query['exhibitor_id'] = vm.exhibitorSelected.id;
            }
            if(vm.admUserSelected !== '' && vm.admUserSelected.id > -1){
               vm.query['adm_user_id'] = vm.admUserSelected.id;
            }
            if(vm.withIssuesSelected !== '' && vm.withIssuesSelected.id > -1){
                vm.query['issues'] = vm.withIssuesSelected.id;
            }
            if(vm.statusSelected !== '' && vm.statusSelected.id > -1){
                vm.query['status'] = vm.statusSelected.id;
            }
            vm.query['page']    = vm.page;
            VirtualFairService.findByPlatformTest(vm.query).then(function(response) {
                vm.flag = true;
                vm.users        = response.data.users;
                vm.totalItems   = response.data.total;
                vm.to           = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
                if(vm.users.length === 0){
                    vm.noResultMessage = 'Sorry, no results were found!';
                } else {
                    vm.noResultMessage = '';
                }
            }).catch(function(err) {

            });
        }

        function getAllVirtualFair() {
            VirtualFairService.getAll().then(function(response) {
                vm.virtualFairs = response.data;
                vm.virtualFairs.unshift({ id : -1, name : 'All'});
            }).catch(function(err) {
            });
        }

        function getAdmUsers() {
            vm.query = {};
            AdmService.getAdmUsersStaff().then(function(response) {
                vm.admUsers = response.data;
                vm.admUsers.unshift({ id : -1, name : 'All'});
            }).catch(function(err) {
            });
        }

        function exhibitorsSelect() {
            vm.query = {};
            vm.query['virtual_fair_id'] = vm.virtualFairSelected.id;
            VirtualFairService.exhibitorsSelect(vm.query).then(function(response) {
                vm.exhibitors = response.data;
                vm.exhibitors.unshift({ id : -1, name : 'All'});
            }).catch(function(err) {
            });
        }

        function openScheduleModal(representative) {
            $uibModal.open({
                templateUrl: 'templates/virtualfairs/report/exhibitor/platform-tests/scheduleTest.modal.html',
                controller: 'ScheduleTestController',
                controllerAs:'scheduleTest',
                resolve:
                    {
                        representative : function () {
                            return representative;
                        }
                    }
            });
        }

        function openScheduleEditModal(representative, test) {
            $uibModal.open({
                templateUrl: 'templates/virtualfairs/report/exhibitor/platform-tests/scheduleTestEdit.modal.html',
                controller: 'ScheduleTestEditController',
                controllerAs:'scheduleTestEdit',
                resolve:
                    {
                        representative : function () {
                            return representative;
                        },
                        test : function () {
                            return test;
                        }
                    }
            });
        }

        function openIssuesModal(representative) {

            $uibModal.open({
                templateUrl: 'templates/virtualfairs/report/exhibitor/platform-tests/scheduleTestIssues.modal.html',
                controller: 'ScheduleTestIssuesController',
                controllerAs:'scheduleTestIssues',
                resolve:
                    {
                        representative : function () {
                            return representative;
                        }
                    }
            });
        }

        function arrayLength(arr)
        {
            return Object.keys(arr).length;
        }
        active();
    }
})();